// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transcript-editor {
  margin-top: 1rem;
  overflow-y: auto;
  padding-top: 1rem;
  max-height: 35rem;
  border-top: 2px solid #2EAEFF;
  padding-right: 1rem;
}


.transcript-editor::-webkit-scrollbar {
  width: 5px;
}

.transcript-editor::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.transcript-editor::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.transcript-editor::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.speechSegment {
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  padding: 0.8rem;
  margin-bottom: 0.9rem;
  background: #fafafa;
}

.segmentHeader {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.timestamp {
  min-width: 85px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0 0.75rem;
  cursor: pointer;
  background: white;
  line-height: 1;
}

.speakerTag {
  max-width: 220px;
  height: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.9rem;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  background: #e0e0e0;
  color: white;
  line-height: 1;
  margin-Bottom: 0.5rem;
}

.speakerTag:hover {
  opacity: 0.8;
  transform: scale(1.05);
}

.speakerTagInput {
  width: 220px;
  height: 32px;
  padding: 0 0.9rem;
  border-radius: 999px;
  outline: none;
  font-size: 0.9rem;
  line-height: 1;
}

.transcriptBox {
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  padding: 0.75rem;
}

.transcriptBox textarea {
  width: 100%;
  border: none;
  resize: none;
  outline: none;
  line-height: 1.5;
}

.speechSegment p {
  margin: 0;
  border: none;
  padding: 0;
}

.speechSegment input {
  resize: none;
}

.editorTranscriptPicker {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 0 0;
    font-size: 16px;
}

.editorTranscriptSelect {
    max-width: 160px;
    text-overflow: ellipsis;
    padding: 0.375rem 0.75rem;
    font-size: 16px;
    line-height: 1.5;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    background: #fff;
    color: #333;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Magor/Studio/TranscriptEditor.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;AACrB;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB","sourcesContent":[".transcript-editor {\n  margin-top: 1rem;\n  overflow-y: auto;\n  padding-top: 1rem;\n  max-height: 35rem;\n  border-top: 2px solid #2EAEFF;\n  padding-right: 1rem;\n}\n\n\n.transcript-editor::-webkit-scrollbar {\n  width: 5px;\n}\n\n.transcript-editor::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.transcript-editor::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 10px;\n}\n\n.transcript-editor::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.speechSegment {\n  border: 1px solid #e4e4e4;\n  border-radius: 8px;\n  padding: 0.8rem;\n  margin-bottom: 0.9rem;\n  background: #fafafa;\n}\n\n.segmentHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.timestamp {\n  min-width: 85px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 0 0.75rem;\n  cursor: pointer;\n  background: white;\n  line-height: 1;\n}\n\n.speakerTag {\n  max-width: 220px;\n  height: 32px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0.9rem;\n  border-radius: 999px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  background: #e0e0e0;\n  color: white;\n  line-height: 1;\n  margin-Bottom: 0.5rem;\n}\n\n.speakerTag:hover {\n  opacity: 0.8;\n  transform: scale(1.05);\n}\n\n.speakerTagInput {\n  width: 220px;\n  height: 32px;\n  padding: 0 0.9rem;\n  border-radius: 999px;\n  outline: none;\n  font-size: 0.9rem;\n  line-height: 1;\n}\n\n.transcriptBox {\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  padding: 0.75rem;\n}\n\n.transcriptBox textarea {\n  width: 100%;\n  border: none;\n  resize: none;\n  outline: none;\n  line-height: 1.5;\n}\n\n.speechSegment p {\n  margin: 0;\n  border: none;\n  padding: 0;\n}\n\n.speechSegment input {\n  resize: none;\n}\n\n.editorTranscriptPicker {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0 0 0 0;\n    font-size: 16px;\n}\n\n.editorTranscriptSelect {\n    max-width: 160px;\n    text-overflow: ellipsis;\n    padding: 0.375rem 0.75rem;\n    font-size: 16px;\n    line-height: 1.5;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    background: #fff;\n    color: #333;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
